<template>
  <div class="container">
    <div style="text-align: center">
      <div id="qrcode" ref="qrcode"></div>
      <div style="margin-top: 10px">凭此二维码入场</div>
    </div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="demo-dynamic" size="mini">
      <el-form-item :label="$t('person.baseInfos.companyName')" prop="company">
        <span>{{ ruleForm.company }}</span>
      </el-form-item>
      <el-form-item :label="$t('person.baseInfos.address')" prop="address">
        <el-input v-model="ruleForm.address"></el-input>
      </el-form-item>
      <el-form-item :label="$t('person.baseInfos.name')" prop="name">
        <span>{{ ruleForm.name }}</span>
      </el-form-item>
      <el-form-item :label="$t('person.baseInfos.named')" prop="named">
        <el-radio v-model="radio" :label="$t('person.baseInfos.named1')">{{ $t('person.baseInfos.named1') }}</el-radio>
        <el-radio v-model="radio" :label="$t('person.baseInfos.named2')">{{ $t('person.baseInfos.named2') }}</el-radio>
      </el-form-item>
      <el-form-item :label="$t('person.baseInfos.type')" prop="column16">
        <span>{{ ruleForm.column16 }}</span>
      </el-form-item>
      <el-form-item :label="$t('person.baseInfos.number')" prop="column15">
        <span>{{ ruleForm.column15 }}</span>
      </el-form-item>
      <el-form-item :label="$t('person.baseInfos.phone')" prop="registAccount">
        <span>{{ ruleForm.registAccount }}</span>
        <!-- <div class="tips">用于发送验证码，以及展会重要参观信息</div> -->
      </el-form-item>
      <el-form-item :label="$t('person.baseInfos.email')" prop="email">
        <el-input v-model="ruleForm.email"></el-input>
        <div class="tips">{{ $t('person.baseInfos.tips.emailTip') }}</div>
      </el-form-item>
      <el-form-item :label="$t('person.baseInfos.dept')" prop="dept">
        <el-input v-model="ruleForm.dept"></el-input>
      </el-form-item>
      <el-form-item :label="$t('person.baseInfos.duty')" prop="duty">
        <el-input v-model="ruleForm.duty"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="submit()">{{ $t('common.save') }}</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getInfo, saveInfo } from '../../../../api/personInfo.js';
import { auth } from '../../../../api/common.js';
import QRCode from 'qrcodejs2'
export default {
  data() {
    return {
      ruleForm: {
        company: '', //公司名称
        address: '', //单位的地址
        name: '', //姓名
        named: '', //称呼
        column16: '', // 证件类型
        column15: '', //	身份证号
        registAccount: '', //手机号
        email: '', //邮箱
        dept: '', //部门
        duty: '', //职位
      },
      rules: {
        // company: [{ required: true, message: '公司名称不能为空' }],
        // column17: [{ required: true, message: '单位地址不能为空' }], //单位的地址
        // name: [{ required: true, message: '姓名不能为空' }], //姓名
        // named: [{ required: true, message: '称呼不能为空' }], //称呼
        // column16: [{ required: true, message: '证件类型不能为空' }], // 证件类型
        column15: [{ required: true, message: this.$t('person.baseInfos.rules.number') }], //	身份证号
        registAccount: [{ required: true, message: this.$t('common.rules.phone') }], //手机号
        email: [{ required: true, message: this.$t('common.rules.email') }], //邮箱
      },
      radio: this.$t('person.baseInfos.named2'),
    };
  },
  methods: {
    // 获取个人信息函数
    async getPersonInfo() {
      try {
        const { data } = await getInfo();
        if (data.code === 200) {
           console.log("获取的个人信息是:",data.data);
           let userInfoData = {... data.data};
           localStorage.removeItem("audienceInfo");  //清除缓存
           localStorage.setItem( "audienceInfo", JSON.stringify(userInfoData)); //更新观众个人信息数据
           this.ruleForm = data.data;
           this.radio = data.data.named;
          let qrcodeContainer = document.getElementById("qrcode");
          qrcodeContainer.innerHTML = "";
          new QRCode(qrcodeContainer, {
            text: userInfoData.column15,
            width: 300,
            height: 300,
            colorDark: "#000000",
            colorLight: "#ffffff",
            correctLevel: QRCode.CorrectLevel.H
          });
        }
      } catch (err) {
        console.log(err.message);
      }
    },

    async submitForm() {
      this.ruleForm.named = this.radio;
      try {
        const { data } = await saveInfo(this.ruleForm);
        if (data.code === 200) {
            this.getPersonInfo(); //提交后更新个人信息数据
        }
      } catch (err) {
        console.log(err.message);
      }
    },
    submit() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.submitForm();
        } else {
            this.$message.error(this.$t('common.require'));
        }
      });
    },
  },
  created() {
    this.getPersonInfo();
  },
};
</script>
<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  //margin: 0 auto;
  //width: 700px;
  //min-height: 656px;

  .tips {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 20px;
  }
}
</style>
<style scoped>
.el-input >>> .el-input__inner {
  width: 500px;
}
.el-form {
  margin-top: 25px;
}
.el-button {
  width: 88px;
  height: 32px;
  background: #006fb8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
}
</style>
